import React from 'react';
import { isNil } from 'lodash-es';
import { Icon, Select } from 'components/antd';

import { GoogleAddressAndFlightData, FlightData } from 'app-types';
import { isFlightItem, isNoFlights } from 'utils/flightsUtils';
import { dateTimeZone } from 'utils/converters';

import classNames from 'classnames';

const Option = Select.Option;

interface Props {
	index: number;
	isPickup?: boolean;
	addressesSuggestions?: GoogleAddressAndFlightData[];

	setAirportType: (airportType: string) => void;
	getPlaceId: (item: GoogleAddressAndFlightData) => string;
}

const getFlightArrival = (item: FlightData) => {
	return `${item.arrivalAirportAddress} ${dateTimeZone(item.arrivalDate)}`;
};

const getFlightDeparture = (item: FlightData) => {
	return `${item.departureAirportAddress} ${dateTimeZone(item.departureDate)}`;
};

const getFullFlightData = (item: FlightData, props: Props, isMiddleLocation?: boolean) => {
	return (
		<span>
			<p
				onClick={() => {
					if (isMiddleLocation) {
						props.setAirportType('departure');
					}
				}}
			>
				{isMiddleLocation && <Icon type={'plane'} />}
				{getFlightDeparture(item)} <span>-></span>
			</p>
			<p
				onClick={() => {
					if (isMiddleLocation) {
						props.setAirportType('arrival');
					}
				}}
			>
				{isMiddleLocation && <Icon type={'plane'} />}
				{getFlightArrival(item)}
			</p>
		</span>
	);
};

export const getOptions = (props: Props) => {
	const { addressesSuggestions, index, isPickup } = props;
	if (isNil(addressesSuggestions) || isNoFlights(addressesSuggestions)) {
		return [];
	}
	const isMiddleLocation = index !== 0 && isPickup;
	return addressesSuggestions.map(item => {
		if (isFlightItem(item)) {
			return (
				<Option
					key={props.getPlaceId(item)}
					className={classNames({ isMiddleLocation: isMiddleLocation })}
				>
					{!isMiddleLocation && <Icon type={'plane'} />}
					{getFullFlightData(item, props, isMiddleLocation)}
				</Option>
			);
		}
		return (
			<Option value={item.placeId} key={item.placeId}>
				<Icon type={'location'} />
				<span>{`${item.fullAddress} (${item.name})`}</span>
			</Option>
		);
	});
};
